export default __webpack_public_path__ + "pizzeria-pin.9a5a16eb.svg";